import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import Breadcrumb from "../Components/BreadCrumb/Breadcrumb";
import GetInTouch from "../Components/Contact/GetInTouch";
import BookATour from "../Components/Contact/BookATour";
import ContactMap from "../Components/Contact/ContactMap";
import FooterFour from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";
import { Helmet } from "react-helmet-async";

function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact Us | Printers Friendly</title>
      </Helmet>
      <HeaderOne />
      <Breadcrumb title="Contact Us" />
      <GetInTouch />
      <BookATour />
      <FooterFour />
      <ScrollToTop />
    </>
  );
}

export default Contact;
